import { orderServiceListQuery, orderServiceCountQuery } from "./orderService";

const model = "kit-configurations";

export const useKitConfigurationList = orderServiceListQuery({ model });
export const useKitConfigurationCount = orderServiceCountQuery({ model });
